// src/pages/ProjectionsPage.js
import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardMedia, Grid, Typography, Link, Box, Chip, CircularProgress, Button } from '@mui/material';
import axios from 'axios';
import './ProjectionsPage.css';
import Sidebar from '../components/Sidebar';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/system';
import config from '../config';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import Collapse from '@mui/material/Collapse';

const generateImageUrls = (id, productInfo) => {
  var productType = "watch";
  var types = ["_with_back", "_shadow", ""];
  var angles = ["0", "-20", "-150"];
  var sizes = ["55", "65"];
  var verticalAngles = ["70", "110"];

  console.log(productInfo)
  if (productInfo) {
    if (productInfo.base_category_id != 11 && productInfo.base_category_id != 1013) {
      productType = "ring";
      types = [""];
      angles = ["0", "-20", "-50"];
      sizes = [""];
      verticalAngles = ["100", "80"];
      console.log(productInfo.base_category_id)
    }
    if (productInfo.base_category_id == 101227) {
      productType = "necklace";
      types = [""]
      angles = ["0", "-30", "30"];
      sizes = ["male", "female"];
      verticalAngles = ["110", "90"];
    }
    if (productInfo.base_category_name.toLowerCase().includes("earrings")) {
      productType = "earrings";
      types = ["_shadow", "_with_back", ""]
      angles = ["45", "5", "-45"];
      sizes = ["1"];
      verticalAngles = ["90"];
    }
  }


  const urlsByCategory = {};
  sizes.forEach(size => {
    urlsByCategory[size] = {};
    angles.forEach(angle => {
      urlsByCategory[size][angle] = {};
      types.forEach(type => {
        urlsByCategory[size][angle][type] = [];
        verticalAngles.forEach(verticalAngle => {
          if (productType == "ring") {
            const url = `https://portalvhdskzpngkvpz6x48.blob.core.windows.net/3d-models/${id}/${verticalAngle}_${angle}.webp`;
            urlsByCategory[size][angle][type].push(url);
          }
          if (productType == "watch") {
            const url = `https://portalvhdskzpngkvpz6x48.blob.core.windows.net/3d-models/${id}/${size}_${verticalAngle}_${angle}${type}.webp`;
            urlsByCategory[size][angle][type].push(url);
          }
          if (productType == "necklace") {
            const mode = size === "female" ? "1" : "2";
            const url = `https://portalvhdskzpngkvpz6x48.blob.core.windows.net/3d-models/${id}/${mode}_${verticalAngle}_${angle}${type}.webp`;
            urlsByCategory[size][angle][type].push(url);
          } else {
            const url = `https://portalvhdskzpngkvpz6x48.blob.core.windows.net/3d-models/${id}/${size}_${verticalAngle}_${angle}${type}.webp`;
            urlsByCategory[size][angle][type].push(url);
          }

        });
      });
    });
  });
  return urlsByCategory;
};

const PageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  alignContent: 'center',
  width: '100%',
  size: '100%',
});

const ContentContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

const lockLabels = {
  true: { label: 'Locked', color: 'error' },
  false: { label: 'Unlocked', color: 'default' },
};

const statusLabels = {
  "-1": { label: 'Waiting', color: 'default' },
  0: { label: 'Rendering', color: 'info' },
  1: { label: 'Error', color: 'error' },
  2: { label: 'Done', color: 'success' },
  null: { label: 'No model', color: 'default' },
  undefined: { label: 'No model', color: 'default' },
};

const sectionCardStyle = {
  marginBottom: 32,
  padding: 24,
  borderRadius: 16,
  boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
  background: '#fafbfc',
};
const sectionHeaderStyle = {
  fontWeight: 700,
  fontSize: '2rem',
  display: 'flex',
  alignItems: 'center',
  marginBottom: 16,
  cursor: 'pointer',
  position: 'sticky',
  top: 0,
  background: '#fafbfc',
  zIndex: 2,
  borderBottom: '1px solid #e0e0e0',
  paddingBottom: 8,
};
const previewImgStyle = {
  maxWidth: 220,
  maxHeight: 220,
  margin: '0 auto',
  borderRadius: 8,
  boxShadow: '0 1px 6px rgba(0,0,0,0.10)',
  border: '1px solid #e0e0e0',
  background: '#fff',
  cursor: 'pointer',
  transition: 'transform 0.2s',
};

const contextModeThumbStyle = {
  maxWidth: 90,
  maxHeight: 90,
  margin: '0 auto',
  borderRadius: 8,
  boxShadow: '0 1px 6px rgba(0,0,0,0.10)',
  border: '1px solid #e0e0e0',
  background: '#fff',
  cursor: 'pointer',
  transition: 'transform 0.2s',
};

const ProjectionsPage = () => {

  const navigate = useNavigate();
  const { id } = useParams();
  const [imagesByCategory, setImagesByCategory] = useState({});
  const [widgetUrl, setWidgetUrl] = useState('');
  const [mainImage, setMainImage] = useState('');
  const [productInfo, setProductInfo] = useState(null);
  const [video_content, setVideoContent] = useState(null);
  const [retailer_url, setRetailerUrl] = useState(null);
  const [extern_id, setExternId] = useState(null);
  const [pomImages, setPomImages] = useState([]);
  const [openImage, setOpenImage] = useState(null);
  const [modelStatus, setModelStatus] = useState(null);
  const [genStatus, setGenStatus] = useState('');
  const [genLoading, setGenLoading] = useState(false);
  const [widgetProjections, setWidgetProjections] = useState([]);
  const [genRequestStatus, setGenRequestStatus] = useState(null);
  const [genPolling, setGenPolling] = useState(false);
  const [contextModes, setContextModes] = useState([]);
  const [framesViewerOpen, setFramesViewerOpen] = useState(false);
  const [framesViewerUrls, setFramesViewerUrls] = useState([]);
  const [framesViewerTitle, setFramesViewerTitle] = useState('');

  // Collapsible section states
  const [pomOpen, setPomOpen] = useState(true);
  const [widgetProjOpen, setWidgetProjOpen] = useState(true);
  const [arClipOpen, setArClipOpen] = useState(true);
  const [roll360Open, setRoll360Open] = useState(true);
  const [wristRollOpen, setWristRollOpen] = useState(true);

  const fetchImages = useCallback(() => {
    if (id) {
      const urlsByCategory = generateImageUrls(id, productInfo);
      setImagesByCategory(urlsByCategory);
    }
  }, [id]);

  const setVideo = useCallback(async (_retailer_domain, _extern_id) => {
    console.log(_retailer_domain, _extern_id)
    if (_retailer_domain && _extern_id) {
      try {
        const response = await axios.get(`${config.productJsonUrl}${_retailer_domain.replaceAll("/", "_")}&${_extern_id.toLowerCase()}.json`);
        const data = response.data;
        setVideoContent(data);
        console.log(data);
      } catch (error) {
        console.error('Error fetching video content:', error);
      }
    }
  });

  const fetchWidgetInfo = useCallback(async () => {
    if (id) {
      try {
        const response = await axios.get(`${config.serverUrl}/products/${id}`);
        const data = response.data;
        setWidgetUrl(data.widget_url);
        setMainImage(data.cover_url);
        setProductInfo(data);
        const urlsByCategory = generateImageUrls(id, data);
        setImagesByCategory(urlsByCategory);
        setRetailerUrl(data.retailer_domain);
        setExternId(data.extern_id);
        setVideo(data.retailer_domain, data.extern_id);
      } catch (error) {
        console.error('Error fetching widget info:', error);
      }
    }
  }, [id]);

  // Function to load image generation status
  const fetchGenRequestStatus = useCallback(async () => {
    if (id) {
      try {
        const response = await axios.get(`${config.serverUrl}/image-generation-status/${id}`);
        setGenRequestStatus(response.data);
      } catch (e) {
        setGenRequestStatus(null);
      }
    }
  }, [id]);

  // Poll generation status if enabled
  useEffect(() => {
    let interval = null;
    if (genPolling) {
      fetchGenRequestStatus();
      interval = setInterval(fetchGenRequestStatus, 3000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [genPolling, fetchGenRequestStatus]);

  // Fetch generation status on mount
  useEffect(() => {
    fetchGenRequestStatus();
  }, [fetchGenRequestStatus]);

  useEffect(() => {
    fetchImages();
    fetchWidgetInfo();
  }, [fetchImages, fetchWidgetInfo]);

  // Load POM images URLs
  useEffect(() => {
    if (id) {
      axios.get(`${config.serverUrl}/pom-images-urls/${id}`)
        .then(res => {
          setPomImages(res.data);
        })
        .catch(err => {
          console.error('Error loading POM images:', err);
        });
    }
  }, [id]);

  // Load model statuses
  useEffect(() => {
    if (id) {
      axios.get(`${config.serverUrl}/model-status/${id}`)
        .then(res => {
          setModelStatus(res.data);
        })
        .catch(err => {
          setModelStatus(null);
        });
    }
  }, [id]);

  // Load Widget Projections
  useEffect(() => {
    if (id) {
      axios.get(`${config.serverUrl}/widget-projections/${id}`)
        .then(res => {
          setWidgetProjections(res.data.projections || []);
        })
        .catch(err => {
          setWidgetProjections([]);
          console.error('Error loading Widget Projections:', err);
        });
    }
  }, [id]);

  // Load Context Modes
  useEffect(() => {
    if (id) {
      axios.get(`${config.serverUrl}/context-modes/${id}`)
        .then(res => {
          setContextModes(res.data || []);
        })
        .catch(err => {
          setContextModes([]);
          console.error('Error loading Context Modes:', err);
        });
    }
  }, [id]);


  const is360Available = video_content?.["360"];
  var frames360 = [];
  if (is360Available) {
    frames360 = [0.15, 0.25, 0.65]
      .map(p => Math.round(video_content["360"].frame_count * p))
      .map(frame => frame.toString().padStart(4, '0'));
  }

  const isWristRollAvailable = video_content?.["wrist_roll"];


  return (

    <PageContainer>
      <Sidebar navigate={navigate} />
      <ContentContainer>
        {productInfo && (
          <>
            <Typography mt={4} mb={4} variant="h6" component="div" gutterBottom>

              <h3>{productInfo.name}</h3>
              <p>
                <Link href={widgetUrl} target="_blank" rel="noopener noreferrer">
                  Open Widget
                </Link>
              </p>
              <p>
                <Link href={productInfo.admin_url} target="_blank" rel="noopener noreferrer">
                  Open Admin
                </Link>
              </p>
            </Typography>
            {/* AR Clip, POM, and rerender statuses */}
            <Box mb={2}>
              {modelStatus ? (
                <Grid container spacing={2}>
                  <Grid item>
                    <Chip
                      label={`AR Clip: ${statusLabels[modelStatus.ar_clip]?.label || 'No model'}`}
                      color={statusLabels[modelStatus.ar_clip]?.color || 'default'}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <Chip
                      label={`POM: ${statusLabels[modelStatus.pom]?.label || 'No model'}`}
                      color={statusLabels[modelStatus.pom]?.color || 'default'}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <Chip
                      label={`VTO Lock: ${lockLabels[!!productInfo.lock_vto].label}`}
                      color={lockLabels[!!productInfo.lock_vto].color}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <Chip
                      label={`POM Lock: ${lockLabels[!!productInfo.lock_pom].label}`}
                      color={lockLabels[!!productInfo.lock_pom].color}
                      variant="outlined"
                    />
                  </Grid>
                  {(modelStatus.rerender_prerender || modelStatus.rerender_pom) && (
                    <Grid item>
                      <Chip
                        label={
                          modelStatus.rerender_prerender && modelStatus.rerender_pom
                            ? 'Ожидает перерендер (AR Clip, POM)'
                            : modelStatus.rerender_prerender
                              ? 'Ожидает перерендер (AR Clip)'
                              : 'Ожидает перерендер (POM)'
                        }
                        color="warning"
                        variant="filled"
                      />
                    </Grid>
                  )}
                </Grid>
              ) : (
                <CircularProgress size={24} />
              )}
            </Box>
          </>
        )}

        <Card style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
          <CardMedia
            component="img"
            image={mainImage}
            style={{ maxWidth: '200px', maxHeight: '30%' }}
          />
        </Card>

        {/* POM Images Section */}
        {pomImages && pomImages.length > 0 && (
          <Card style={sectionCardStyle}>
            <Box style={sectionHeaderStyle} onClick={() => setPomOpen(!pomOpen)}>
              {pomOpen ? <ExpandLess /> : <ExpandMore />}
              <span style={{ marginLeft: 8 }}>POM Images</span>
            </Box>
            <Collapse in={pomOpen} timeout="auto" unmountOnExit>
              <Grid container spacing={4}>
                {pomImages.map((item, idx) => (
                  <Grid item xs={12} sm={6} md={4} key={idx}>
                    <Card style={{ padding: 16, minHeight: 420, background: '#fff', borderRadius: 12 }}>
                      <Typography variant="h6" gutterBottom>
                        {item.context_mode}
                      </Typography>
                      <Box display="flex" flexDirection="row" justifyContent="space-between" mb={2}>
                        <Box textAlign="center">
                          <Typography variant="subtitle2">Product</Typography>
                          <CardMedia
                            component="img"
                            image={item.product_url}
                            style={previewImgStyle}
                            onClick={() => setOpenImage(item.product_url)}
                          />
                        </Box>
                        <Box textAlign="center">
                          <Typography variant="subtitle2">Mask</Typography>
                          <CardMedia
                            component="img"
                            image={item.mask_url}
                            style={previewImgStyle}
                            onClick={() => setOpenImage(item.mask_url)}
                          />
                        </Box>
                        <Box textAlign="center">
                          <Typography variant="subtitle2">Shadow</Typography>
                          <CardMedia
                            component="img"
                            image={item.shadow_url}
                            style={previewImgStyle}
                            onClick={() => setOpenImage(item.shadow_url)}
                          />
                        </Box>
                        {item.final_url && (
                          <Box textAlign="center">
                            <Typography variant="subtitle2">Final</Typography>
                            <CardMedia
                              component="img"
                              image={item.final_url}
                              style={previewImgStyle}
                              onClick={() => setOpenImage(item.final_url)}
                            />
                          </Box>
                        )}
                      </Box>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Collapse>
            <Dialog open={!!openImage} onClose={() => setOpenImage(null)} maxWidth="xl">
              <DialogContent style={{ background: '#222' }}>
                <img src={openImage} alt="POM enlarged" style={{ maxWidth: '90vw', maxHeight: '90vh', display: 'block', margin: 'auto' }} />
              </DialogContent>
            </Dialog>
          </Card>
        )}
        <Card style={sectionCardStyle}>
          <Box style={sectionHeaderStyle} onClick={() => setWidgetProjOpen(!widgetProjOpen)}>
            {widgetProjOpen ? <ExpandLess /> : <ExpandMore />}
            <span style={{ marginLeft: 8 }}>Widget Projections</span>
          </Box>
          <Collapse in={widgetProjOpen} timeout="auto" unmountOnExit>
            <Box mb={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={async () => {
                  setGenStatus('');
                  setGenLoading(true);
                  try {
                    const response = await axios.post(`${config.serverUrl}/image-generation-request`, { product_ids: id });
                    setGenStatus('Generation requested successfully!');
                    setGenPolling(true); // Start polling
                  } catch (e) {
                    setGenStatus('Error during generation: ' + (e?.response?.data?.detail || e.message));
                  } finally {
                    setGenLoading(false);
                  }
                }}
                disabled={genLoading}
              >
                {genLoading ? 'Generating...' : 'Generate projection'}
              </Button>
              {/* New Complex Config button */}
              {productInfo && (
                <Button
                  variant="outlined"
                  color="info"
                  style={{ marginLeft: 16 }}
                  component="a"
                  href={`https://yrulermgr.triplenext.net/Admin/Configuration/Complex?RetailerId=${productInfo.retailer_id}&CategoryId=${productInfo.category_id}&TagId=${productInfo.tag}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Complex Config
                </Button>
              )}
              {genStatus && (
                <Typography variant="body2" color={genStatus.startsWith('Error') ? 'error' : 'success'} sx={{ mt: 1 }}>
                  {genStatus}
                </Typography>
              )}
              {/* Widget projections generation status */}
              <Box mt={2}>
                {genRequestStatus ? (
                  <>
                    <Typography variant="body2">
                      <b>Widget projections generation status:</b> {genRequestStatus.IsDone == 1 ? 'Done' : 'In progress'}<br />
                      <b>Last update:</b> {genRequestStatus.UpdatedAt}<br />
                      <b>UserName:</b> {genRequestStatus.UserName} <br />
                    </Typography>
                    {genRequestStatus.IsDone == 1 && genPolling && (
                      (() => { setGenPolling(false); return null; })()
                    )}
                  </>
                ) : (
                  <Typography variant="body2" color="textSecondary">No data about generation</Typography>
                )}
              </Box>
            </Box>
            {/* Context Modes */}
            {contextModes && contextModes.length > 0 && (
              <Box mb={4}>
                <Typography variant="h5" gutterBottom>Context Modes</Typography>
                <Grid container spacing={2}>
                  {contextModes.map((mode, idx) => (
                    <Grid item xs={6} sm={4} md={3} key={mode.Id || idx}>
                      <Card style={{ padding: 8, background: '#fff', borderRadius: 10, minHeight: 120, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Typography variant="body2" gutterBottom style={{ textAlign: 'center' }}>
                          {mode.TitleOverride || `Mode ${mode.ContextModeId}`}
                        </Typography>
                        {mode.LightThumbUrl && (
                          <CardMedia
                            component="img"
                            image={mode.LightThumbUrl}
                            style={contextModeThumbStyle}
                            alt={mode.TitleOverride || `Mode ${mode.ContextModeId}`}
                          />
                        )}
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}
            {/* Widget Projections Section */}
            {widgetProjections && widgetProjections.length > 0 && (
              <Box mt={6} mb={6}>
                <Typography variant="h5" gutterBottom>Projection</Typography>
                <Grid container spacing={4}>
                  {widgetProjections.map((item, idx) => (
                    <Grid item xs={12} sm={6} md={4} key={idx}>
                      <Card style={{ padding: 16, background: '#fff', borderRadius: 12 }}>
                        <Typography variant="h6" gutterBottom>
                          {item.ProjectionName}
                        </Typography>
                        <Box display="flex" flexDirection="column" alignItems="center">
                          <CardMedia
                            component="img"
                            image={item.CloudUrl}
                            style={previewImgStyle}
                            onClick={() => setOpenImage(item.CloudUrl)}
                          />
                          <Typography variant="body2" color="textSecondary" mt={1}>
                            ID: {item.Id}
                          </Typography>
                        </Box>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
                <Dialog open={!!openImage} onClose={() => setOpenImage(null)} maxWidth="xl">
                  <DialogContent style={{ background: '#222' }}>
                    <img src={openImage} alt="Widget Projection enlarged" style={{ maxWidth: '90vw', maxHeight: '90vh', display: 'block', margin: 'auto' }} />
                  </DialogContent>
                </Dialog>
              </Box>
            )}
          </Collapse>
        </Card>

        <Card style={sectionCardStyle}>
          <Box style={sectionHeaderStyle} onClick={() => setRoll360Open(!roll360Open)}>
            {roll360Open ? <ExpandLess /> : <ExpandMore />}
            <Typography variant="h4" gutterBottom ml={1}>360</Typography>
          </Box>
          <Collapse in={roll360Open} timeout="auto" unmountOnExit>
            {is360Available && (
              <Box>
                <Grid container spacing={2}>
                  {frames360.map(frame => (
                    <Grid item xs={12} sm={6} md={4} key={frame}>
                      <Card style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 12, background: '#fff', borderRadius: 12 }}>
                        <CardMedia
                          component="img"
                          image={`${video_content["360"].url}${frame}.webp`}
                          style={previewImgStyle}
                        />
                      </Card>
                    </Grid>
                  ))}
                </Grid>
                <Box mt={2}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => {
                      const count = video_content["360"].frame_count || 0;
                      const urls = Array.from({ length: count }, (_, i) => (i + 1))
                        .map(n => n.toString().padStart(4, '0'))
                        .map(frame => `${video_content["360"].url}${frame}.webp`);
                      setFramesViewerUrls(urls);
                      setFramesViewerTitle('Все кадры 360');
                      setFramesViewerOpen(true);
                    }}
                  >
                    Показать все кадры
                  </Button>
                </Box>
              </Box>
            )}
          </Collapse>
        </Card>
        <Card style={sectionCardStyle}>
          <Box style={sectionHeaderStyle} onClick={() => setWristRollOpen(!wristRollOpen)}>
            {wristRollOpen ? <ExpandLess /> : <ExpandMore />}
            <Typography variant="h4" gutterBottom ml={1}>Wrist Roll</Typography>
          </Box>
          <Collapse in={wristRollOpen} timeout="auto" unmountOnExit>
            {isWristRollAvailable && (
              <Box>
                {video_content["wrist_roll"].map((wr, idx) => {
                  const frames = [0.15, 0.25, 0.65]
                    .map(p => Math.round(wr.frame_count * p))
                    .map(frame => frame.toString().padStart(4, '0'));
                  return (
                    <Box key={idx} mb={2}>
                      <Typography variant="subtitle1">Запись {idx + 1}</Typography>
                      <Grid container spacing={2}>
                        {frames.map(frame => (
                          <Grid item xs={12} sm={6} md={4} key={frame}>
                            <Card style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 12, background: '#fff', borderRadius: 12 }}>
                              <CardMedia
                                component="img"
                                image={`${wr.url}${frame}.webp`}
                                style={previewImgStyle}
                              />
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                      <Box mt={1}>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            const count = wr.frame_count || 0;
                            const urls = Array.from({ length: count }, (_, i) => (i + 1))
                              .map(n => n.toString().padStart(4, '0'))
                              .map(frame => `${wr.url}${frame}.webp`);
                            setFramesViewerUrls(urls);
                            setFramesViewerTitle(`Все кадры Wrist Roll ${idx + 1}`);
                            setFramesViewerOpen(true);
                          }}
                        >
                          Показать все кадры
                        </Button>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            )}
          </Collapse>
        </Card>
        {/* POM Videos Section */}
        {video_content?.["pom_video"] && video_content["pom_video"].length > 0 && (
          <Card style={sectionCardStyle}>
            <Box style={sectionHeaderStyle}>
              <Typography variant="h4" gutterBottom ml={1}>POM Videos</Typography>
            </Box>
            <Collapse in={true} timeout="auto" unmountOnExit>
              <Grid container spacing={4}>
                {video_content["pom_video"].map((pv, idx) => (
                  <Grid item xs={12} sm={6} md={4} key={idx}>
                    <Card style={{ padding: 16, background: '#fff', borderRadius: 12 }}>
                      <Typography variant="h6" gutterBottom>
                        Видео {idx + 1}
                      </Typography>
                      <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="flex-start" gap={2}>
                        {pv.thumb && (
                          <Box textAlign="center" flex={1}>
                            <Typography variant="subtitle2">Thumb</Typography>
                            <CardMedia component="img" image={pv.thumb} style={previewImgStyle} onClick={() => setOpenImage(pv.thumb)} />
                          </Box>
                        )}
                        <Box textAlign="center" flex={2}>
                          <Typography variant="subtitle2">Video</Typography>
                          <video src={pv.url} controls style={{ width: '100%', borderRadius: 8, border: '1px solid #e0e0e0' }} />
                        </Box>
                      </Box>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Collapse>
          </Card>
        )}
        {/* Static Images Section */}
        {video_content?.["static"] && video_content["static"].length > 0 && (
          <Card style={sectionCardStyle}>
            <Box style={sectionHeaderStyle}>
              <Typography variant="h4" gutterBottom ml={1}>Static Images</Typography>
            </Box>
            <Collapse in={true} timeout="auto" unmountOnExit>
              <Grid container spacing={2}>
                {video_content["static"].map((st, idx) => (
                  <Grid item xs={12} sm={6} md={4} key={idx}>
                    <Card style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 12, background: '#fff', borderRadius: 12 }}>
                      <CardMedia component="img" image={"https://portalvhdskzpngkvpz6x48.blob.core.windows.net/3d-models/" + st.url} style={previewImgStyle} onClick={() => setOpenImage("https://portalvhdskzpngkvpz6x48.blob.core.windows.net/3d-models/" + st.url)} />
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Collapse>
          </Card>
        )}
        <Card style={sectionCardStyle}>
          <Box style={sectionHeaderStyle} onClick={() => setArClipOpen(!arClipOpen)}>
            {arClipOpen ? <ExpandLess /> : <ExpandMore />}
            <span style={{ marginLeft: 8 }}>AR Clip Projections</span>
          </Box>
          <Collapse in={arClipOpen} timeout="auto" unmountOnExit>
            <Grid container spacing={4}>
              {Object.keys(imagesByCategory).map(size => (
                <Grid item key={size} xs={12} sm={6}>
                  <Box mb={4}>
                    <Typography variant="h5" component="div" gutterBottom>
                      Size: {size}
                    </Typography>
                    {Object.keys(imagesByCategory[size]).map(angle => (
                      <Box key={angle} ml={2} mb={4}>
                        <Typography variant="h6" component="div" gutterBottom>
                          Angle: {angle}
                        </Typography>
                        {Object.keys(imagesByCategory[size][angle]).map(type => (
                          <Box key={type} ml={4} mb={4}>
                            <Typography variant="subtitle1" component="div" gutterBottom>
                              Type: {type || 'default'}
                            </Typography>
                            <Grid container spacing={2}>
                              {imagesByCategory[size][angle][type].map((src, index) => (
                                <Grid item key={index} xs={4} sm={4} md={4} lg={4}>
                                  <Card className="image-card" style={{ background: '#fff', borderRadius: 8, boxShadow: '0 1px 6px rgba(0,0,0,0.10)' }}>
                                    <CardMedia
                                      component="img"
                                      image={src}
                                      alt={`3D Model ${index}`}
                                      className="image"
                                      style={previewImgStyle}
                                    />
                                  </Card>
                                </Grid>
                              ))}
                            </Grid>
                          </Box>
                        ))}
                      </Box>
                    ))}
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Collapse>
        </Card>


      </ContentContainer>
      {/* Frames viewer dialog */}
      <Dialog open={framesViewerOpen} onClose={() => setFramesViewerOpen(false)} maxWidth="xl">
        <DialogContent style={{ background: '#222' }}>
          <Typography variant="h6" gutterBottom style={{ color: '#fff' }}>{framesViewerTitle}</Typography>
          <Box sx={{ maxHeight: '80vh', overflowY: 'auto' }}>
            <Grid container spacing={2}>
              {framesViewerUrls.map((src, i) => (
                <Grid item xs={6} sm={4} md={3} lg={2} key={i}>
                  <img src={src} alt={`frame-${i}`} style={{ width: '100%', borderRadius: 8 }} />
                </Grid>
              ))}
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>
    </PageContainer>
  );
};

export default ProjectionsPage;
